import React from 'react';

import NotificationsProvider from './NotificationsProvider';
import ToastProvider from './ToastProvider';
import RowHeightProvider from './RowHeightProvider';
import PopupEntityAppProvider from './PopupEntityAppProvider';
import InsightsChatProvider from 'contextProviders/InsightsChatProvider';
import InsightsContentProvider from 'contextProviders/InsightsContentProvider';
import InjectedComponentsProvider from 'contextProviders/InjectedComponentsProvider';

const MiscProviders = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => (
  <NotificationsProvider>
    <ToastProvider>
      <RowHeightProvider>
        <PopupEntityAppProvider>
          <InsightsContentProvider>
            <InsightsChatProvider>
              <InjectedComponentsProvider>
                {children}
              </InjectedComponentsProvider>
            </InsightsChatProvider>
          </InsightsContentProvider>
        </PopupEntityAppProvider>
      </RowHeightProvider>
    </ToastProvider>
  </NotificationsProvider>
);

export default MiscProviders;
